var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_4527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4001 1.6H1.6001V0H22.4001V1.6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61554 3.84306C1.69033 3.46912 2.01866 3.19995 2.40001 3.19995H21.6C21.9814 3.19995 22.3097 3.46912 22.3845 3.84306L23.9845 11.8431C24.0315 12.0781 23.9706 12.3218 23.8187 12.5072C23.6667 12.6925 23.4397 12.8 23.2 12.8H0.800007C0.560332 12.8 0.333284 12.6925 0.181333 12.5072C0.0293822 12.3218 -0.0314617 12.0781 0.0155423 11.8431L1.61554 3.84306Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6 14.3999V22.3999H0V23.9999H24V22.3999H22.4V14.3999H19.2V17.5999H4.8V14.3999H1.6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3999 14.3999H17.5999V15.9999H6.3999V14.3999Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_4527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreTraffic);
export default __webpack_public_path__ + "static/media/store-traffic.aa81912d9255191f9298f52c7e85569a.svg";
export { ForwardRef as ReactComponent };